import { render, staticRenderFns } from "./samecityChildlistEdit.vue?vue&type=template&id=b2c1730c&scoped=true"
import script from "./samecityChildlistEdit.vue?vue&type=script&lang=js"
export * from "./samecityChildlistEdit.vue?vue&type=script&lang=js"
import style0 from "./samecityChildlistEdit.vue?vue&type=style&index=0&id=b2c1730c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c1730c",
  null
  
)

export default component.exports